import { connect } from "react-redux";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import Modal from "../../../utils/customModal";
import { withTranslation } from "react-i18next";
import TokenComponent from "../../../shared/token";
import { MOD_PROVID } from "../../../../permissions";
import * as instanceActions from "../../../../Redux/api";
import StatusBadge from "canvas-core-react/lib/StatusBadge";
import TableAdmissions from "../../../shared/admissions/table";
import { getModules } from "../../../../Redux/reducer/clients";
import noAproval from "../../../../../static/images/add-client-bsc.svg";
import ProviderTemporal from "../../../shared/provider/providerTemporal";
import * as ProviderActions from "../../../../Redux/actions/providerActions";
import { getAuthenticatedClientModules } from "../../../../Redux/actions/clientActions";
import {
  loadingHtml,
  errorContainer,
  sucessInfoModal,
  getNumberApprovals,
} from "../../../utils/functions";
import {
  getPendingProviders,
  getTotalPendingProviders,
} from "../../../../Redux/reducer/providers";
import ActionMenuList from "canvas-core-react/lib/ActionMenuList";
import ActionMenuListItem from "canvas-core-react/lib/ActionMenuListItem";
import IconShow from "canvas-core-react/lib/IconShow";
import { LABELS_ACCOUNT_TYPE } from "../../../shared/AccountTypeSelect";

const defaultFilters = [
  { property: "pendingChange", operator: "eq", value: "true" },
];
let signal;

export class ApprovalProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: defaultFilters,
      page: 0,
      sizePerPage: 10,
      contentReady: false,
      modal: { show: false, content: null, onClose: undefined },
      token: { show: false, code: null },
      data: { approve: undefined, elements: undefined },
      menus: [],
      list: true,
      component: false,
      companyId: 0,
      providerId: 0,
      currency: null,
    };
    this.controller = new AbortController();
    signal = this.controller.signal;
  }

  componentDidMount() {
    var customFilters = this.getFilters();

    this.props.setFilters({
      filterItems: customFilters,
      filterSearch: this.searchFnc,
    });

    if (this.props.clientModules.length <= 0) {
      this.props.getModules();
    }

    return this.getPendingData();
  }

  componentWillUnmount() {
    this.props.actions.clearPendingProviders();
    this.controller.abort();
  }

  getFilters() {
    return [
      {
        name: `${this.props.t("general.filters.name")}`,
        property: "provider.institution.name",
        operator: "eq",
      },
      {
        name: `${this.props.t("general.filters.identification")}`,
        property: "provider.institution.businessId",
        operator: "eq",
      },
    ];
  }

  getPendingData() {
    const { getPendingProviders } = this.props.actions;
    const { page, sizePerPage, filter } = this.state;
    return getPendingProviders(page, sizePerPage, filter, signal).then(() => {
      this.setState({ contentReady: true });
    });
  }

  searchFnc = (property, value) => {
    var { filter } = this.state;
    var currentFilters = [];
    console.log(property);
    console.log(value);
    console.log(filter);
    if (value !== "") {
      var operator = "";
      var customFilters = this.getFilters();

      customFilters.map((item) => {
        if (item.property == property) {
          operator = item.operator;
        }
      });

      currentFilters = [
        ...filter,
        { property: property, operator: operator, value: value },
      ];
    } else {
      currentFilters = defaultFilters;
    }

    this.setState({ page: 0, filter: currentFilters }, () => {
      return this.getPendingData();
    });
  };

  getData() {
    const { pending, t } = this.props;
    var resultData = [];

    if (pending.length > 0) {
      pending.map((item) => {
        if (item.estado === "TRANSITORY") {
          item.estado = (
            <StatusBadge className="pending-client" type="default">
              {t("general.states.PENDING")}
            </StatusBadge>
          );
        }
        resultData.push({
          id: item?.id,
          cedJuridica: item?.cedJurdica,
          name: (
            <p
              className={"admission-p record"}
              onClick={(e) => this.openInfoTemp(e, item)}
            >
              {item?.empresa}
            </p>
          ),
          status: item?.estado,
          payMethod:
            LABELS_ACCOUNT_TYPE[item?.provider?.accounts[0]?.accountType] ||
            item?.provider?.accounts[0]?.accountType ||
            "-",
          bank:
            item.provider?.accounts[0] !== undefined
              ? item?.provider.accounts[0].bicDestinationBank
              : "-",
          account:
            item.provider?.accounts[0] !== undefined
              ? item?.provider.accounts[0].accountNumber
              : "-",
          item,
        });
      });
    }

    return resultData;
  }

  closeInfo = () => {
    this.setState(
      { page: 0, filter: defaultFilters, list: true, component: false, contentReady: false },
      () => {
        return this.getPendingData();
      }
    );
  };

  handlerTableChange = ({ page, sizePerPage }) => {
    const { getPendingProviders } = this.props.actions;

    return getPendingProviders(
      page,
      sizePerPage,
      this.state.filter,
      signal
    ).then(() => {
      this.setState({ page, sizePerPage });
    });
  };

  closeModal = () => {
    this.setState({
      modal: { show: false, content: null, onClose: undefined },
    });
  };

  finishAdmission = () => {
    const { t } = this.props;
    var buttons = {
      SelBtn: {
        text: `${t("general.buttons.continue")}`,
        action: this.closeModal,
      },
    };

    var content = sucessInfoModal(
      `${t("admissions.successModal.title")}`,
      `${t("admissions.successModal.message")}`,
      buttons
    );

    this.setState({ modal: { content: content, show: true, showClose: true } });
  };

  validate = ({ validToken = null }) => {
    const { token } = this.state;

    if (validToken === null) {
      token.show = true;
      this.setState({ token });
    } else {
      token.show = false;
      token.code = validToken;
      this.setState({ token }, () => this.commitActions());
    }
  };

  handleMenu = (id, open) => {
    const { menus } = this.state;
    menus[`menu-${id}`] = open;
    this.setState({ menus });
  };

  getHeaders() {
    const { menus } = this.state;
    const { t } = this.props;
    return [
      { selector: "name", name: `${t("admissions.headers.suppliers.name")}` },
      {
        selector: "cedJuridica",
        name: `${t("admissions.headers.suppliers.id")}`,
      },
      {
        selector: "payMethod",
        name: `${t("admissions.headers.suppliers.payMethod")}`,
      },
      { selector: "bank", name: `${t("admissions.headers.suppliers.bank")}` },
      {
        selector: "account",
        name: `${t("admissions.headers.suppliers.account")}`,
      },
      {
        selector: "status",
        name: `${t("admissions.headers.suppliers.status")}`,
      },
      {
        selector: "accion",
        name: `${t("providers.table.headers.action")}`,
        center: true,
        cellFormatter: (row) => (
          // console.log('row', row)
          <ActionMenuList
            dialogPosition="bottom-right"
            iconType="horizontal-small"
            bottomSheet={{
              heading: "Actions",
              secondaryAction: {
                onClick: () => {},
                label: "Cancel",
              },
            }}
            isMenuOpen={menus[`menu-${row.account}-${row.id}`] || false}
            setIsMenuOpen={(open) =>
              this.handleMenu([`${row.account}-${row.id}`], open)
            }
          >
            <ActionMenuListItem
              icon={() => <IconShow className="TextButton__icon--left" />}
              onClick={(e) => this.openInfoTemp(e, row.item)}
            >
              {t(`general.labels.viewProfile`)}
            </ActionMenuListItem>
          </ActionMenuList>
        ),
      },
    ];
  }

  openInfoTemp = (e, item) => {
    e.preventDefault();
    this.setState({ menus: [] }, () =>
      this.setState({
        list: false,
        component: true,
        companyId: item.provider.relation.company.id,
        providerId: item.provider.id,
        currency: item.provider.currencyAux,
      })
    );
  };

  // TODO: Fix passTests for test, "TRUE" for pass test
  commitActions = (approve, elements, passTests) => {
    const { modal, token, data } = this.state;
    const {
      instance: { instanceAction },
      t,
    } = this.props;

    data.approve = approve !== undefined ? approve : data.approve;
    data.elements = elements !== undefined ? elements : data.elements;

    var approvals = getNumberApprovals(this.props.clientModules, MOD_PROVID);

    // TODO: Antes estuvo en 1, pendiente de observacion
    if (approvals >= 0 && !passTests) {
      if (token.code === null) {
        token.show = true;
        this.setState({ token, data });
        return false;
      }
    }

    modal.content = loadingHtml();
    modal.show = true;

    data.approve = approve !== undefined ? approve : data.approve;
    data.elements = elements !== undefined ? elements : data.elements;

    this.setState({ modal, data });
    var updateStates = [];

    var apiHeader =
      token.code !== null ? { "x-security-code": token.code } : {};

    Object.keys(data.elements).map((key) => {
      const [, idProvider, currency] = key.split("-");

      updateStates.push({
        providerId: idProvider,
        approve: data.approve,
        currency,
      });

      return true;
    });

    return instanceAction(
      "/providers/me/approve-or-rejected",
      "put",
      updateStates,
      apiHeader
    )
      .then((response) => {
        const { modal } = this.state;
        if (response.data.data[0].success === false) {
          modal.show = true;
          modal.content = errorContainer(
            `${t("general.labels.errorTitle")}`,
            response.data.data[0].message,
            {
              continueBtn: {
                text: `${t("general.buttons.continue")}`,
                action: this.closeModal,
              },
            }
          );
        } else if (response.data.notifications == null) {
          this.finishAdmission();
        }

        modal.onClose = () => this.closeModal();

        this.setState({
          contentReady: false,
          token: { show: false, code: null },
        });
        this.getPendingData();
      })
      .catch((err) => {
        if (
          err.response !== undefined &&
          Array.isArray(err.response.data.notifications)
        ) {
          const notification = err.response.data.notifications[0];
          modal.content = errorContainer(
            notification.message,
            notification.description,
            {
              cancelBtn: {
                text: `${t("general.buttons.close")}`,
                action: () => this.closeModal(),
              },
            }
          );
        }
        modal.onClose = () => this.closeModal();

        this.setState({
          contentReady: false,
          modal,
          token: { show: false, valid: false },
        });
        return this.getPendingData();
      });
  };

  goBack = () => {
    this.setState({ token: { show: false, code: null } });
  };

  render() {
    const {
      contentReady,
      sizePerPage,
      page,
      component,
      companyId,
      providerId,
      currency,
      list,
      token,
    } = this.state;

    var data = this.getData();
    const { t } = this.props;

    return (
      <React.Fragment>
        {contentReady ? (
          this.props.pending.length > 0 ? (
            list && (
              <React.Fragment>
                <TableAdmissions
                  headers={this.getHeaders()}
                  data={data}
                  page={page}
                  totalSize={this.props.total}
                  sizePerPage={sizePerPage}
                  addmissionType={`providers`}
                  onTableChange={this.handlerTableChange}
                  submitAdmissions={this.commitActions}
                />
                {token.show && (
                  <TokenComponent send={this.validate} goBack={this.goBack} />
                )}
              </React.Fragment>
            )
          ) : (
            <div id="blankAprrovals">
              <img src={noAproval} className="clientImage" />
              <p>{t("admissions.noAdmissions")}</p>
              <div className="line red"></div>
            </div>
          )
        ) : (
          <div className="loader innner"></div>
        )}
        {component && (
          <ProviderTemporal
            closeInfo={this.closeInfo}
            companyId={companyId}
            providerId={providerId}
            currency={currency}
          />
        )}
        <Modal
          show={this.state.modal.show}
          handleClose={this.state.modal.onClose}
        >
          {this.state.modal.content}
        </Modal>
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    pending: getPendingProviders(state),
    total: getTotalPendingProviders(state),
    clientModules: getModules(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(ProviderActions, dispatch),
    instance: bindActionCreators(instanceActions, dispatch),
    getModules: () => dispatch(getAuthenticatedClientModules()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatch
)(withTranslation()(ApprovalProvider));
